var $D = $(document);
var $H = $('html');

$(function(){
	var $popup = $('.js-popup');
	var $wrapper = $('.js-wrapper');
	var inProgress = false;
	var scrollPosition;

	if (location.hash !== '') {
		getEventItem(location.hash.substr(1));
		$('#events').toggleClass('active').removeClass('inactive');
	}

	$(document).on('click', '.js-popup-btn', function(e){
		e.preventDefault();
		var id = $(this).attr('href');
		var url = $(this).data('url');
		var index = $(this).data('index');
		var activePopup = $(id);
		$popup.not(id).removeClass('active').removeClass('inactive');
		activePopup.toggleClass('active').removeClass('inactive');
		scrollPosition = $(window).scrollTop();

		if (url) {
			setLocationHash(url);
			getEventItem(url);
		}

		var form = activePopup.find('form');
		if (form.length) {
			if (!form.hasClass('__no_focus')) {
				form.find('input:not([type="hidden"])').first().focus();
			}
		}

		if(index >=0) {
			$('.js-iframe').attr('src',__app.TEMPLATE_URI+'/samoletmeridian/samoletmeridian.html#'+index);
		}

		return false
	});

	$(document).on('click', '.js-popup-close', function(){
		$(this).parents('.popup').removeClass('active').addClass('inactive');
		window.location.hash = '';
		history.pushState(null, null, window.location.href.split('#')[0]);
		$('.popup__content').scrollTop(0);
		if (scrollPosition !== "undefined") {
			$(window).scrollTop(scrollPosition);
			scrollPosition = undefined;
		}
		$('.js-iframe').attr('src','');
	});

	// закрываем попапы при клике вне области
	$D.on('mouseup touchend',function (e) {
		var popup = $(".popup");
		if (!$('.js-popup-btn').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
			popup.removeClass('popup-show').addClass('inactive');
			if (scrollPosition !== "undefined") {
				$(window).scrollTop(scrollPosition);
				scrollPosition = undefined;
			}
		}
	});

	function getEventItem(item) {
		$.ajax({
			url: item,
			type: "GET",
			beforeSend: function () {
				inProgress = true;
			},
			success: function(data) {
				if ($(data).length !== 0) {
					$wrapper.html($(data));
					inProgress = false;
				}
			}
		});
	}

	function setLocationHash(url) {
		window.location.hash = url.substring(0,url.length-5);
	}

	$('.popup-vacancies__btn').on('click', function(){
		$(this).closest('.popup').find('input:not([type="hidden"])').first().focus();
	});
});
